import React from 'react';
import PendingActionsOutlined from '@mui/icons-material/PendingActionsOutlined';
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import StatCard from '../StatCard'

const CardMedicoesPendentes = (props) => {
  const totalMedicoesPendentes = useSelector((state) => state.dashboard?.dashboard?.totalMedicoesPendentes)

  return (
    <StatCard
      {...props}
      label="Medições pendentes de aprovação"
      value={totalMedicoesPendentes ? totalMedicoesPendentes : 0}
      icon={<PendingActionsOutlined />}
    />
  );
}

CardMedicoesPendentes.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
}

export default CardMedicoesPendentes
